"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCut = void 0;

var process_data_1 = require("./process-data");

var processCut = function processCut(_ref) {
  var product = _ref.product,
      form = _ref.form,
      productShape = _ref.productShape,
      cutShape = _ref.cutShape;
  var key = "".concat(product).concat(form).concat(productShape || "").concat(cutShape || "");
  var result = process_data_1.processCutData.get(key);
  return result || [];
};

exports.processCut = processCut;